import { render, staticRenderFns } from "./prise-en-charge-assurance-proprietaire.vue?vue&type=template&id=0b8a929a&scoped=true"
import script from "./prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"
export * from "./prise-en-charge-assurance-proprietaire.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a929a",
  null
  
)

export default component.exports